import React from 'react';
import SectionH2 from '../heading/SectionH2';
import CheckmarkDark from '../../img/checkmark_dark.svg';
import Checkmark from '../../img/checkmark.svg';
import { useAnalyticsEventTracker } from '../../utils/analytics';

const APP_STORE_IOS =
  'https://apps.apple.com/app/apple-store/id1513284627?pt=121388959&ct=Business%20Pricing&mt=8';

const Pricing = ({ theme = 'light' }) => {
  const eventTracker = useAnalyticsEventTracker('BusinessPricing');

  const pricingPlans = [
    {
      name: 'Business',
      description: 'Manage multiple buildings from one account',
      features: [
        'Automate building entry',
        'Audit access history',
        'Manage multiple buildings from one account',
        'Use with multiple residential units',
        'Invite your team to manage buildings across devices',
        'Unlimited passcodes and routines',
      ],
      missingFeatures: [],
      price: '$41.67 / month',
      priceSubtext: '($500.00 billed annually)',
      priceNote: '$250 base + $250 per building',
      color: '#41E1B0',
      cta: 'Start Your 14 Day Trial',
      ctaHref: APP_STORE_IOS,
    },
  ];

  const pricingComponent = (plan, index) => {
    return (
      <div
        key={index}
        style={{
          boxShadow: `inset 0 0 20px 1px ${plan.color}`,
          borderColor: `${plan.color}`,
          borderWidth: 1,
        }}
        className="flex h-full w-full flex-grow flex-row justify-center rounded-lg bg-gray-900 text-white sm:w-2/3 sm:max-w-md md:w-96"
      >
        <div className="flex w-full flex-col space-y-5 py-6 px-9 text-center font-space-grotesk-regular lg:w-96">
          <div className="flex flex-col space-y-1">
            <h3 className="font-syne-bold text-3xl font-bold">{plan.name}</h3>
            <p className="text-lg">{plan.description}</p>
          </div>
          <div className="flex flex-col space-y-3">
            {plan.features.map((feature, index) => (
              <li key={index} className="flex flex-row items-center justify-between text-left text-sm">
                {feature}
                <img src={Checkmark} alt={'white checkmark icon'} class="h-3 w-3 object-contain" />
              </li>
            ))}
            {plan.missingFeatures.map((feature, index) => (
              <li key={index} className="flex flex-row items-center justify-start text-sm line-through opacity-50">
                {feature}
              </li>
            ))}
          </div>
          <div className="flex flex-grow flex-col justify-end">
            {!!plan.price && (
              <div>
                <div>
                  <span className="font-syne-bold text-2xl">{plan.price}</span>
                </div>
                {!!plan.priceSubtext && (
                  <div>
                    <span className="text-gray-400">{plan.priceSubtext}</span>
                  </div>
                )}
                {!!plan.priceNote && (
                  <div>
                    <span className="text-gray-400">{plan.priceNote}</span>
                  </div>
                )}
              </div>
            )}
            <a
              href={plan.ctaHref}
              target="_blank"
              rel="noreferrer"
              onClick={() => eventTracker('Lead', plan.name, 'Contact')}
              className="mt-3 rounded bg-yellow-lowkey py-2 px-4 font-syne-bold text-black"
            >
              {plan.cta}
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="px-8">
      <div className="flex flex-col items-center pb-5 sm:pb-11">
        <SectionH2 title={'Plans & Pricing'} theme={theme} />
        <div className="flex w-full max-w-2xl flex-row flex-wrap items-center justify-around gap-2 sm:flex-row sm:flex-nowrap sm:justify-around sm:gap-0 sm:space-y-0 xl:max-w-3xl">
          <div className="hidden flex-row space-x-3 sm:flex">
            <img src={CheckmarkDark} alt={'white checkmark icon'} class="mx-auto object-contain" />
            <p class="whitespace-nowrap">Lifetime money back guarantee</p>
          </div>

          <div className="flex flex-grow flex-row justify-center sm:hidden">
            <div className="flex flex-row space-x-3">
              <img src={CheckmarkDark} alt={'white checkmark icon'} class="mx-auto object-contain" />
              <p class="whitespace-nowrap">Lifetime money back guarantee</p>
            </div>
          </div>
        </div>
        <div class="max-w-4xl space-y-4 pt-4 text-center">
          <p class="font-space-grotesk-regular">
            If you are ever unsatisfied with the service, we will solve your problem or give you a{' '}
            <span class="font-space-grotesk-medium font-bold italic">full lifetime refund.</span>
          </p>
        </div>
      </div>

      <div class="flex flex-grow flex-row justify-center overflow-x-auto sm:-mx-8 sm:px-8 sm:pt-5">
        <div className="flex w-full flex-col items-center space-y-4 sm:space-y-6 lg:flex-row lg:justify-center lg:space-y-0 lg:space-x-4 xl:space-x-6 2xl:space-x-8">
          {pricingPlans.map((plan, index) => pricingComponent(plan, index))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;
